export default __webpack_public_path__ + "static/graphik-medium-web-89aea9a9aa1f248c97a59407e08e409d.woff2";